var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg004BarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,357.122c11.046,0,20-8.954,20-20v-141c0-40.804-33.196-74-74-74s-74,33.196-74,74V438c0,40.804,33.196,74,74,74 s74-33.196,74-74c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,18.748-15.252,34-34,34s-34-15.252-34-34V196.122 c0-18.748,15.252-34,34-34s34,15.252,34,34v141C472,348.168,480.954,357.122,492,357.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,183.122c-40.804,0-74,33.196-74,74V438c0,40.804,33.196,74,74,74s74-33.196,74-74V257.122 C148,216.318,114.804,183.122,74,183.122z M108,438c0,18.748-15.252,34-34,34s-34-15.252-34-34V257.122c0-18.748,15.252-34,34-34 s34,15.252,34,34V438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0c-40.804,0-74,33.196-74,74v364c0,40.804,33.196,74,74,74s74-33.196,74-74V74C330,33.196,296.804,0,256,0z M290,438 c0,18.748-15.252,34-34,34s-34-15.252-34-34V74c0-18.748,15.252-34,34-34s34,15.252,34,34V438z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004BarChart);
export default __webpack_public_path__ + "static/media/004-bar-chart.615c10c25181c7348e83c6d5de3981d3.svg";
export { ForwardRef as ReactComponent };